/**
 * @file make
 * @author 丁聪
 */

import React, { Component } from 'react'
import { changePopup, changeMenu } from 'src/redux/basicInfo'
import { connect } from 'react-redux'

import './index.scss'

@connect((state) => state, { changePopup, changeMenu })

class Make extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  handlePermit = () => {
    this.props.changePopup({ type: 'trial', status: true })
  }

  componentDidMount() { }

  render() {
    let makeList = [1, 2, 3, 4, 5]
    return (
      <div id="make">
        <div className="inner">
          <div className="make-title">打造优质上课体验</div>
          <div className="heng"></div>
          <ul className="previews">
            {makeList.map((item) => (
              <li className='previews-list' key={item}></li>
            ))}
          </ul>
          <button className="but" onClick={this.handlePermit}>立即申请</button>
        </div>
      </div>
    )
  }
}

export default Make
